import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Color, Size } from 'const'

export const Checkbox = ({ check, onClick, text = '', checkboxWidth = '', justify = '', align = '' }) => (
  <CheckboxBlock checkboxWidth={checkboxWidth} justify={justify} align={align}>
    <CheckboxArea>
      <CheckboxLabel check={check} onClick={onClick} />
    </CheckboxArea>
    <CheckboxText>{text}</CheckboxText>
  </CheckboxBlock>
)

const CheckboxBlock = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.checkboxWidth ? props.checkboxWidth : '40px')} 1fr;
  justify-self: ${(props) => (props.justify ? props.justify : 'center')};
  align-self: ${(props) => (props.align ? props.align : 'center')};
`
const CheckboxArea = styled.div`
  position: relative;
`
const getRadioLabelAfter = (props) => {
  let css = ``

  if (props.check) {
    css = `
      content: '';
      display: block;
      position: absolute;
      top: 5px;
      left: 5px;
      width: 12px;
      height: 12px;
      border-radius: 6px;
      background: #10131a;
    `

    return css
  }
}
const CheckboxLabel = styled.span`
  ${(props) => css`
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      background-color: #fff;
      border: 1px solid #f4f4f4;
      border-radius: 10px;
      cursor: pointer;
    }
    &:after {
      ${getRadioLabelAfter(props)}
    }
  `}
`
const CheckboxText = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.NORMAL};
  padding-top: 2px;
  white-space: pre-line;
`

Checkbox.propTypes = {
  check: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  checkboxWidth: PropTypes.string,
  justify: PropTypes.string,
  align: PropTypes.string,
}
